"use client";

import { c as _c } from "react/compiler-runtime";
import { useFilter } from "@/components/filters/filter-context";
import { Button } from "@/components/ui/button";
import { SheetClose } from "@/components/ui/sheet";
export function ApplyFiltersButton() {
  const $ = _c(4);
  const {
    applyFilters,
    hasPendingChanges
  } = useFilter();
  const t0 = !hasPendingChanges;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span>Aplicar</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== applyFilters || $[2] !== t0) {
    t2 = <SheetClose asChild={true}><Button variant="default" size="sm" className="w-7/12" onClick={applyFilters} disabled={t0}>{t1}</Button></SheetClose>;
    $[1] = applyFilters;
    $[2] = t0;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}